import { render, staticRenderFns } from "./Log_Reg.vue?vue&type=template&id=750aa26a"
import script from "./Log_Reg.vue?vue&type=script&lang=js"
export * from "./Log_Reg.vue?vue&type=script&lang=js"
import style0 from "./Log_Reg.vue?vue&type=style&index=0&id=750aa26a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports